<template>
  <div id="app" >
    <app-header></app-header>
    <router-view></router-view>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    "app-header": Header,
    "app-footer": Footer
  },
  mounted() {},
  computed: {
    // isLogin() {
    //   if (this.$route.name === "Login") {
    //     return true;
    //   }
    //   return false;
    // }
  }
};
</script>

<style>
html {
  height: 100%;
  box-sizing: border-box;
  
}

body {
  position: relative;
  margin: 0;
  min-height: 100%;
  height: 100%;
}

#app{
  overflow: hidden;
}
.carousel__item {
  height: auto;
}
.carousel__item .item img {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue